<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton';
</script>

<template>
	<div class="flex w-full flex-col gap-6">
		<Skeleton variant="white" class="h-[54px] w-[359px]" is-active />
		<Skeleton variant="white" class="h-[31px] w-full" is-active />
		<div class="flex gap-5 overflow-hidden">
			<Skeleton
				v-for="i in 3"
				:key="i"
				variant="white"
				class="h-[400px] min-w-[342px] md:min-w-[48%] lg:h-[460px] lg:min-w-[calc((100%_-_40px)_/_3)]"
				is-active
			/>
		</div>
		<div class="flex justify-end gap-3">
			<Skeleton
				v-for="i in 6"
				:key="i"
				variant="white"
				class="h-0.5 w-[60px]"
				is-active
			/>
		</div>
	</div>
</template>
